import { render, staticRenderFns } from "./ErroR404.vue?vue&type=template&id=3b7788b6&"
import script from "./ErroR404.vue?vue&type=script&lang=js&"
export * from "./ErroR404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports